module.exports = __webpack_public_path__ + "img/10.89fca48a.png";